/*
 * Copy to Clipboard Component
 */
if (!customElements.get("copy-to-clipboard")) {
  class CopyToClipboard extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector("button");
      this.originalText = this.button ? this.button.firstChild.textContent.trim() : "";
      this.tooltipText = this.dataset.tooltipText;
      this.copiedText = this.dataset.copiedText;
      this.copiedTimeout = null;
      this.tooltipElement = null;
    }

    connectedCallback() {
      if (!this.button) return;

      this.button.addEventListener("click", this.handleCopy.bind(this));
      this.button.addEventListener("mouseenter", this.showTooltip.bind(this));
      this.button.addEventListener("mouseleave", this.hideTooltip.bind(this));
      this.button.addEventListener("focus", this.showTooltip.bind(this));
      this.button.addEventListener("blur", this.hideTooltip.bind(this));
    }

    disconnectedCallback() {
      if (!this.button) return;

      this.button.removeEventListener("click", this.handleCopy.bind(this));
      this.button.removeEventListener("mouseenter", this.showTooltip.bind(this));
      this.button.removeEventListener("mouseleave", this.hideTooltip.bind(this));
      this.button.removeEventListener("focus", this.showTooltip.bind(this));
      this.button.removeEventListener("blur", this.hideTooltip.bind(this));

      if (this.copiedTimeout) {
        clearTimeout(this.copiedTimeout);
      }
    }

    async handleCopy(event) {
      event.preventDefault();

      try {
        await navigator.clipboard.writeText(this.originalText);
        this.showCopiedState();
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    }

    showCopiedState() {
      if (!this.button) return;

      // Update tooltip to "Copied!"
      this.updateTooltipText(this.copiedText);

      // Add copied class for styling
      this.button.classList.add("is-copied");

      // Clear any existing timeout
      if (this.copiedTimeout) {
        clearTimeout(this.copiedTimeout);
      }

      // Reset after 2 seconds
      this.copiedTimeout = setTimeout(() => {
        this.button.classList.remove("is-copied");
        if (this.tooltipElement) {
          this.updateTooltipText(this.tooltipText);
        }
      }, 2000);
    }

    showTooltip() {
      if (!this.button) return;

      // Don't show tooltip if already exists
      if (this.tooltipElement) return;

      const tooltipText = this.button.classList.contains("is-copied")
        ? this.copiedText
        : this.tooltipText;

      this.tooltipElement = document.createElement("div");
      this.tooltipElement.className = "copy-tooltip";
      this.tooltipElement.textContent = tooltipText;
      this.appendChild(this.tooltipElement);

      // Trigger reflow for animation
      setTimeout(() => {
        this.tooltipElement?.classList.add("is-visible");
      }, 10);
    }

    hideTooltip() {
      if (!this.tooltipElement) return;

      this.tooltipElement.classList.remove("is-visible");

      setTimeout(() => {
        if (this.tooltipElement && this.tooltipElement.parentNode) {
          this.tooltipElement.remove();
          this.tooltipElement = null;
        }
      }, 200);
    }

    updateTooltipText(text) {
      if (this.tooltipElement) {
        this.tooltipElement.textContent = text;
      }
    }
  }

  customElements.define("copy-to-clipboard", CopyToClipboard);
}
